import { type CanDeactivateFn } from '@angular/router';

/** A screen that can hold edits nobody has saved. */
export interface HasUnsavedChanges {
  hasUnsavedChanges(): boolean;
}

/** What the leave prompt asks. */
export const UNSAVED_CHANGES_PROMPT =
  'You have unsaved changes to this draft. Leave without saving?';

/**
 * Asks before leaving a screen with unsaved edits (GOV-04, ruling Q8.4). The
 * browser's own leave prompt covers a reload or a closed tab: the screen
 * handles `beforeunload` itself.
 *
 * Kept free of imports beyond the router's types, because the route table
 * that names it is eager.
 */
export const unsavedChangesGuard: CanDeactivateFn<HasUnsavedChanges> = (component) =>
  !component?.hasUnsavedChanges() || window.confirm(UNSAVED_CHANGES_PROMPT);
